import React from 'react';
import { injectIntl } from 'react-intl';

import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { locationShape, intlShape } from '../../shared/shapes';
import WidgetHeader from './WidgetHeader';
import { buildOfficeSchedulingUrl } from '../../shared/utils/urls';

const WidgetProviderHeader = ({ intl, provider, location }) => (
  <WidgetHeader
    title={provider.display}
    subtitle={provider.office.display}
    photo={provider.profile.photo}
    photo2x={provider.profile.photo2x}
    changeUrl={buildOfficeSchedulingUrl(provider.office.id, { location })}
    changeText={intl.formatMessage({
      id: 'widgets.WidgetProviderHeader.changeText',
      defaultMessage: 'Change Provider',
    })}
    showBackButton
  />
);

WidgetProviderHeader.propTypes = {
  // eslint-disable-next-line react/no-typos
  intl: intlShape,
  provider: PropTypes.shape({
    display: PropTypes.string.isRequired,
    office: PropTypes.shape({
      id: PropTypes.string.isRequired,
      display: PropTypes.string.isRequired,
    }).isRequired,
    profile: PropTypes.shape({
      photo: PropTypes.string.isRequired,
      photo2x: PropTypes.string.isRequired,
    }),
  }).isRequired,
  location: locationShape,
};

export default withRouter(injectIntl(WidgetProviderHeader));
